export default {
  allSubTagsOf: 'همه‌ی برچسب‌هایی که زیرمجموعه‌ی یکی از برچسب‌های زیر هستند:',
  allTagsOf: 'همه‌ی برچسب‌های زیر:',
  chooseChoice: 'تعریف گزینه‌ها',
  chooseChoiceType: 'گزینه‌های ممکن برای این سؤال به چه صورتی باشد؟',
  choicesMessage: 'گزینه‌های ممکن برای این سؤال: ',
  chooseTag: 'انتخاب از بین برچسب‌ها',
  selectTag: 'انتخاب برچسب',
  choicesViewMode: 'نحوه‌ی نمایش گزینه‌ها',
  listView: 'همه',
  popupView: 'به صورت لیست با قابلیت جستجو',
  theAnswerHasTheAbilityToSelectMultipleOptions:
    'امکان انتخاب چند گزینه وجود داشته باشد',
  aQuestoinCouldNotBeDistinctiveAndMultiSelectAtSameTime:
    'یک سوال نمی‌تواند هم متمایز باشد و هم چند پاسخه',
  moveToTags: 'انتقال به برچسب‌ها',
  defaultValue: 'مقدار پیشفرض',
  fillPermissionSchemeList: 'طرح دسترسی تکمیل این سوال',
  reportPermissionSchemeList: 'طرح دسترسی مشاهده پاسخ‌ها/گزارش این سوال',
  exclude: 'به جز',
  permissionScheme: 'طرح دسترسی به گزینه‌ها',
  analyseReportPermissionSchemeList: 'طرح دسترسی مشاهده تحلیل',
  analyseFillPermissionSchemeList: 'طرح دسترسی ثبت تحلیل',
};
